import { colors } from '@kmns-internal/furikake/tokens'
import { Stack, Typography } from '@mui/material'
import { SubmissionRateProgress } from 'src/features/monitoringDashboardAlpha/components/SubmissionRateProgress/SubmissionRateProgress'

type Props = {
  /** 実施率（0〜100 のパーセント値） */
  rate: number
}

/**
 * 実施率を表す横棒グラフ + パーセント表示
 *
 * PD コメント: 実施率のバーには Primary を利用する。
 */
export const SubmissionRateBar = ({ rate }: Props) => {
  const isComplete = rate >= 100

  return (
    <Stack spacing={0.5} sx={{ minWidth: 160 }}>
      <Stack direction="row" justifyContent="flex-end">
        <Typography
          variant="subtitle2"
          sx={{
            // Figma: 100% のときだけ primary、それ以外は通常テキスト色
            color: isComplete ? colors.primary.main : colors.text.primary,
          }}
        >
          {rate}%
        </Typography>
      </Stack>
      <SubmissionRateProgress rate={rate} />
    </Stack>
  )
}
